export const EXTERNAL_BANK_ACCOUNT_TYPE_CHECKING = 'checking' as const
export const EXTERNAL_BANK_ACCOUNT_TYPE_SAVINGS = 'savings' as const
export const EXTERNAL_BANK_ACCOUNT_TYPES = [
  EXTERNAL_BANK_ACCOUNT_TYPE_CHECKING,
  EXTERNAL_BANK_ACCOUNT_TYPE_SAVINGS
] as const
export type ExternalBankAccountType = (typeof EXTERNAL_BANK_ACCOUNT_TYPES)[number]

export const EXTERNAL_BANK_ACCOUNT_HOLDER_TYPE_INDIVIDUAL = 'individual' as const
export const EXTERNAL_BANK_ACCOUNT_HOLDER_TYPE_COMPANY = 'company' as const
export const EXTERNAL_BANK_ACCOUNT_HOLDER_TYPES = [
  EXTERNAL_BANK_ACCOUNT_HOLDER_TYPE_INDIVIDUAL,
  EXTERNAL_BANK_ACCOUNT_HOLDER_TYPE_COMPANY
] as const
export type ExternalBankAccountHolderType = (typeof EXTERNAL_BANK_ACCOUNT_HOLDER_TYPES)[number]

export const EXTERNAL_BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED = 'unverified' as const
export const EXTERNAL_BANK_ACCOUNT_VERIFICATION_STATUS_PENDING = 'pending' as const
export const EXTERNAL_BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED = 'verified' as const
export const EXTERNAL_BANK_ACCOUNT_VERIFICATION_STATUS_FAILED = 'failed' as const
export const EXTERNAL_BANK_ACCOUNT_VERIFICATION_STATUSES = [
  EXTERNAL_BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED,
  EXTERNAL_BANK_ACCOUNT_VERIFICATION_STATUS_PENDING,
  EXTERNAL_BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED,
  EXTERNAL_BANK_ACCOUNT_VERIFICATION_STATUS_FAILED
] as const
export type ExternalBankAccountVerificationStatus = (typeof EXTERNAL_BANK_ACCOUNT_VERIFICATION_STATUSES)[number]

export const PAYMENT_NETWORK_ACH = 'ach' as const
export const PAYMENT_NETWORK_WIRE = 'us_domestic_wire' as const
export const BANK_PAYMENT_NETWORKS = [PAYMENT_NETWORK_ACH, PAYMENT_NETWORK_WIRE] as const
export type BankPaymentNetwork = (typeof BANK_PAYMENT_NETWORKS)[number]
